import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { VehicleSummaryTemplate } from '@components/v2/VehicleSummary/VehicleSummaryTemplate';
import { rem } from 'polished';
import { PriceCss } from '@components/v2/OrderPanel/OrderPanelStyled';

export const VehicleSummaryStyled = styled(VehicleSummaryTemplate)`
    width: 100%;
    position: sticky;
    top: ${({ isUserLoggedInAsDealer }) => (isUserLoggedInAsDealer ? rem(36) : 0)};

    .offerValidityDate {
        margin-top: ${rem('15px')};
        width: 100%;
        display: flex;
        padding-top: ${rem('15px')};
        padding-bottom: ${rem('15px')};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
    }

    .benefits {
        @media (max-width: ${breakpoints.sm}px) {
            padding: unset;
        }
    }

    .summary-price-container {
        ${PriceCss}

        @media (max-width: ${breakpoints.sm}px) {
            display: none;
        }

        .content {
            width: 100%;
            .header {
                flex-direction: column;

                .catalog-price-title {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding-top: ${rem('15px')};
                    padding-bottom: ${rem('15px')};
                    border-top: 1px solid ${({ theme }) => theme.colors.grey26};
                    border-bottom: 1px solid ${({ theme }) => theme.colors.grey26};
                    font-size: ${rem('12px')};
                    margin-bottom: ${rem('15px')};
                }

                .divider {
                    display: none;
                }
            }
        }
        .body {
            justify-content: space-between;
            width: 100%;
            .body-wrapper {
                width: 100%;
                flex-direction: column;
                align-items: flex-end;

                .totalMonthlyPriceWrapper {
                    justify-content: flex-end;
                }

                .footer {
                    width: 100%;
                    text-align: right;
                    max-width: unset;
                }

                .heading-wrapper {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;

                    .heading {
                        font-weight: bold;
                        font-size: ${({ theme }) => theme.fontSizes.textBase};
                    }
                }
            }
        }
    }

    .calculator {
        display: none;
    }
`;
